module.exports = __webpack_public_path__ + "media/images/front/top/dplus_20240613-c9f97f16a0cb2f6a9e6ba720668d35dd.jpeg";